import React, { useCallback, useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
interface NavbarProps {
  handlePurchase: () => void;
}
export function Navbar({
  handlePurchase
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = useCallback(() => setIsOpen(false), []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) closeMenu();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeMenu]);
  return <>
      <nav className="sticky top-0 z-[9999] bg-dark/90 backdrop-blur-md border-b border-gold/15 h-[70px] flex items-center justify-between px-[5%]" role="navigation" aria-label="Navegación principal" data-id="element-205">
        <div className="font-serif italic text-gold text-xl font-bold tracking-[2px]" data-id="element-206">
          EL CÓDIGO 888
        </div>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center" data-id="element-207">
          <a href="#la-frecuencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-208">
            La Frecuencia
          </a>
          <a href="#la-ciencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-209">
            La Ciencia
          </a>
          <a href="#testimonios" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-gold mr-5" data-id="element-210">
            Resultados
          </a>
          <a href="#hoy-te-llevas" className="text-gold text-[11px] font-extrabold uppercase border-b-2 border-gold pb-[2px] mr-5" data-id="element-211">
            Hoy Te Llevas
          </a>
          <a href="#protocolo" className="bg-gold text-dark text-[11px] font-extrabold px-6 py-2.5 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] hover:scale-105 transition-transform uppercase tracking-wide inline-block" data-id="element-212">
            ACTIVAR - $14
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button className="lg:hidden text-gold p-2" onClick={toggleMenu} aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isOpen} aria-controls="mobile-menu" data-id="element-213">
          {isOpen ? <X size={28} data-id="element-214" /> : <Menu size={28} data-id="element-215" />}
        </button>
      </nav>

      {/* Mobile Overlay */}
      {isOpen && <div id="mobile-menu" role="dialog" aria-modal="true" aria-label="Menú de navegación" className="fixed inset-0 top-[70px] bg-dark/95 backdrop-blur-xl z-[9998] flex flex-col items-center pt-12 space-y-8 lg:hidden" data-id="element-216">
          <a href="#la-frecuencia" onClick={toggleMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-217">
            La Frecuencia
          </a>
          <a href="#la-ciencia" onClick={toggleMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-218">
            La Ciencia
          </a>
          <a href="#hoy-te-llevas" onClick={toggleMenu} className="text-gold text-sm font-extrabold uppercase tracking-[2px]" data-id="element-219">
            Hoy Te Llevas
          </a>
          <a href="#protocolo" onClick={toggleMenu} className="mt-4 bg-gold text-dark text-sm font-extrabold px-8 py-3 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] uppercase tracking-wide inline-block" data-id="element-220">
            Acceso por $14
          </a>
        </div>}
    </>;
}